/**
 * Patient-level Medical History. Does not write Encounter, Note, or NoteVersion.
 */
import { api } from "@/lib/orgApi";

export function isPmhWrite(url) {
  const path = String(url || "");
  return /medical-history/.test(path);
}

export function isEncounterOrNoteWrite(url) {
  const path = String(url || "");
  return /\/encounters(\/|$)/.test(path) || /\/notes(\/|$)/.test(path) || /\/versions(\/|$)/.test(path);
}

export async function listMedicalHistory(patientId) {
  if (!patientId) return { items: [], review: null, catalogs: null };
  const { data } = await api.get(`/patients/${encodeURIComponent(patientId)}/medical-history`);
  return {
    items: data.items || [],
    review: data.review || null,
    catalogs: data.catalogs || null,
  };
}

export async function createMedicalHistory(patientId, payload) {
  const { data } = await api.post(
    `/patients/${encodeURIComponent(patientId)}/medical-history`,
    payload,
  );
  return data;
}

export async function updateMedicalHistory(itemId, payload) {
  const { data } = await api.put(`/medical-history/${encodeURIComponent(itemId)}`, payload);
  return data;
}

export async function removeMedicalHistory(itemId) {
  const { data } = await api.delete(`/medical-history/${encodeURIComponent(itemId)}`);
  return data;
}

export async function reviewMedicalHistory(patientId) {
  const { data } = await api.post(
    `/patients/${encodeURIComponent(patientId)}/medical-history/review`,
  );
  return data;
}
